import moment from "moment";
import React from "react";
import { withRouter } from "react-router-dom";

import Button from "@/components/UI/Button";

export const diReminderWidget = (props) => {
  const { call, onSubmit } = props;

  const localizedCallDateTime = moment.utc(call.timestamp, "YYYY-MM-DD HH:mm").local();
  const localizedCallDate = localizedCallDateTime.format("MMMM DD, YYYY");
  const localizedCallTime = localizedCallDateTime.format("hh:mm A");

  const changeAppointment = () => {
    onSubmit();
    props.history.push("/app/schedule/available");
  };

  return (
    <>
      <div
        className="d-flex flex-column align-items-center fs-lg-22 fs-16 my-4 text-align-center tw:justify-center tw:font-bold"
        style={{ color: "#668391" }}
      >
        <p className="mb-0">Therapist Consultation with {call.provider_name}</p>
        <div className="d-flex">
          <p>{localizedCallDate}</p>
          <span className="mx-1">&bull;</span>
          <p>{localizedCallTime}</p>
        </div>
      </div>
      <div className="text-center my-3">
        <Button
          className="Btn Btn-med Btn--pri tw:font-bold"
          onClick={changeAppointment}
          style={{ padding: "10px 20px", textDecoration: "none" }}
        >
          Change Appointment
        </Button>
      </div>
    </>
  );
};

export const DIReminderWidget = React.memo(withRouter(diReminderWidget));
